<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content">
    <div class="title-box">
      <span class="title">{{ "GLOBAL_CONFIG" | translate }}</span>
    </div>

    <div class="container">
      <form nz-form [formGroup]="validateModuleForm">
        <nz-form-item>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired nzFor="title">{{
            "MENU_TITLE" | translate
          }}</nz-form-label>
          <nz-form-control
            [nzSm]="10"
            [nzXs]="24"
            [nzErrorTip]="
              'PLACEHOLDER_PLEASE_INPUT'
                | translate : { name: 'MENU_TITLE' | translate }
            "
          >
            <textarea
              nz-input
              formControlName="title"
              id="title"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'MENU_TITLE' | translate }
              "
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="logo">{{
            "MENU_LOGO" | translate
          }}</nz-form-label>
          <nz-form-control [nzSm]="10" [nzXs]="24">
            <nz-upload
              [(nzFileList)]="fileList"
              [nzBeforeUpload]="onBeforeUpload"
              nzListType="picture-card"
              [nzShowButton]="fileList.length < 1"
              [nzShowUploadList]="false"
              nzAccept="image/png, image/jpeg, image/jpg, image/svg+xml"
            >
              <div class="upload-btn">
                <span
                  class="upload-icon"
                  nz-icon
                  [nzType]="imageLoading ? 'loading' : 'plus'"
                ></span>
                <div class="ant-upload-text">
                  {{ "UPLOAD" | translate }}
                </div>
              </div>
            </nz-upload>
            <div *ngIf="fileList.length" class="upload-image-box">
              <img [src]="fileList[0].url" />
              <div class="icon-list">
                <span
                  nz-icon
                  nzType="eye"
                  nzTheme="outline"
                  (click)="previewVisible = true"
                ></span>
                <span
                  nz-icon
                  nzType="delete"
                  nzTheme="outline"
                  (click)="fileList = []"
                ></span>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="8" [nzXs]="24"></nz-form-label>
          <nz-form-control [nzSm]="16" [nzXs]="24">
            <div class="ctrl" [nzSm]="16">
              <button nz-button nzType="primary" (click)="onSaveConfirm()">
                <span>{{ "SAVE" | translate }}</span>
              </button>
              <button nz-button nzType="default" (click)="onCancel()">
                <span>{{ "RESET" | translate }}</span>
              </button>
            </div>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
  </div>
</nz-spin>
<nz-modal
  [nzVisible]="previewVisible"
  [nzContent]="modalContent"
  [nzFooter]="null"
  (nzOnCancel)="previewVisible = false"
>
  <ng-template #modalContent>
    <div class="img-preview">
      <img [src]="fileList[0].url" [ngStyle]="{ width: '80%' }" />
    </div>
  </ng-template>
</nz-modal>
